import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Kicker } from '@/components/Kicker';

export default function AdminRequests() {
  const { t } = useTranslation();
  const q = useQuery({ queryKey: ['admin', 'requests'], queryFn: async () => (await api.get('/admin/requests')).data });
  const items = q.data?.items || [];
  return (
    <section>
      <Kicker>{t('admin.title')}</Kicker>
      <h1 className="mt-3 font-display text-3xl font-semibold text-[#14171C]">{t('admin.nav.requests')}</h1>
      <div className="mt-8 pn-card overflow-hidden">
        <table className="w-full text-left text-sm" data-testid="admin-requests-table">
          <thead className="bg-[#F6F8FB] text-xs uppercase tracking-wide text-[#4A4D52]">
            <tr>
              <th className="px-4 py-3">Datum</th>
              <th className="px-4 py-3">Kontakt</th>
              <th className="px-4 py-3">Firma</th>
              <th className="px-4 py-3">Produkt</th>
              <th className="px-4 py-3">Typ</th>
              <th className="px-4 py-3">Menge</th>
              <th className="px-4 py-3">Nachricht</th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id} className="border-t border-[#E4E9F0] hover:bg-[#F6F8FB] align-top">
                <td className="px-4 py-3 font-mono text-xs text-[#4A4D52]">{new Date(r.created_at).toLocaleString()}</td>
                <td className="px-4 py-3"><div>{r.contact_name}</div><div className="text-xs text-[#4A4D52]">{r.contact_email}</div></td>
                <td className="px-4 py-3">{r.company || '—'}</td>
                <td className="px-4 py-3">{r.product_name}<div className="font-mono text-xs text-[#4A4D52]">{r.product_ref || ''}</div></td>
                <td className="px-4 py-3"><span className="inline-flex rounded-full bg-[#FBEADD] px-2 py-0.5 text-xs font-semibold text-[#E2611C]">{r.request_type}</span></td>
                <td className="px-4 py-3 text-xs">{r.quantity || '—'}</td>
                <td className="px-4 py-3 text-xs text-[#4A4D52] max-w-[300px]">{r.message || ''}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-[#4A4D52]">{t('catalog.empty')}</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
